import { _validationIssueTypes } from 'global/cnr/contexts/useHelpers/useCleanData'
import { useEventInfo } from 'global/cnr/contexts/useHelpers/useEventInfo'
import { convertHelpers } from 'global/common/convert'
import ItemMenuSquares, { _imsTypes } from 'global/wrappers/ItemMenuSquares'
import _ from 'lodash'
import { useMemo, useState } from 'react'
import { Icon, Label } from 'semantic-ui-react'

const ImsDataIssues = ({
  currentVds,
  handleSelected
}) => {

  const { eventInfo } = useEventInfo()
  const { eventDups } = eventInfo ?? {}

  const { _dataUpdates, data, appDoc } = currentVds ?? {}

  const data_updates = useMemo(() => {
    const mis = _.mapValues(_dataUpdates, (du, duk) => ({
      name: data?.[duk] ? convertHelpers.getItemName(data?.[duk]) : _.startCase(appDoc),
      _itemKey: duk,
      dataIssues: du,
    }));
    return mis
  }, [_dataUpdates])

  const [selectedItems, setSelectedItems] = useState({})

  const handleSectedItems = (e, item) => {
    const _selectedItems = _.cloneDeep(selectedItems)
    _selectedItems[item?._itemKey] = !_selectedItems[item?._itemKey]
    setSelectedItems(_selectedItems)
    handleSelected(_selectedItems)
  }

  const fnAlt = (item) => {
    return <Label size='mini' color={'blue'}>{_.size(item?.dataIssues)}</Label>
  }

  const icon_props = (dataIssue) => {
    switch (dataIssue.updateType) {
      case _validationIssueTypes.emptyObject:
        return { color: 'grey', icon: 'code' }
      case _validationIssueTypes.emptyString:
        return { color: 'violet', icon: 'code' }
      case _validationIssueTypes.emptyArray:
        return { color: 'orange', icon: 'code' }
      case _validationIssueTypes.duplicateArrayItems:
        return { color: 'purple', icon: 'clone outline' }
      case _validationIssueTypes.invalidNumber:
        return { color: 'teal', icon: 'question' }
      case _validationIssueTypes.duplicateItems:
        return { color: 'brown', icon: 'clone outline' }
      case _validationIssueTypes.missingArrayKeys:
        return { color: 'pink', icon: 'question' }
      default:
        return { color: 'yellow', icon: 'code' }
    }
  }

  const lbls_div = (path, dataIssue, ml) => {
    const { updateType, itemProp, value } = dataIssue ?? {}
    let _div = <div>{updateType}</div>
    switch (updateType) {
      case _validationIssueTypes.emptyObject:
      case _validationIssueTypes.emptyString:
      case _validationIssueTypes.emptyArray:
        _div = <div>{itemProp}</div>
        // _div = <div>{dataIssue?.name ? `${path} - ${dataIssue?.name}` : `${path}`}</div>
        break;
      case _validationIssueTypes.duplicateArrayItems:
        _div = <div>{`${itemProp} [${value}]`}</div>
        break;
      case _validationIssueTypes.invalidNumber:
        _div = <div>{dataIssue?.name ? `${path} - ${dataIssue?.name}` : `${path}`}</div>
        break;
      case _validationIssueTypes.duplicateItems:
        _div = <div>{dataIssue?.name ? `${path} - ${dataIssue?.name}` : `${path}`}</div>
        break;
      case _validationIssueTypes.missingArrayKeys:
        _div = <div>{`${itemProp} [${value}]`}</div>
        // _div = <div>{dataIssue?.name ? `${path} - ${dataIssue?.name}` : `${path}`}</div>
        break;
    }

    const { icon, color } = icon_props(dataIssue)

    return <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: ml || null }}>
      {_div}
      <div>
        <Icon
          name={icon}
          color={color}
          title={_.startCase(dataIssue?.updateType)}
        />
      </div>
    </div>
  }

  const lbls_remove = (path, dataItem, dataIssue, ml) => {
    const seletedItem = selectedItems?.[dataItem._itemKey]
    return <div style={{ display: 'flex', justifyContent: 'space-between', marginLeft: ml || null }}>
      <div>{`${path} - ${dataItem?.name}`}</div>
      <div
        onClick={(e) => { handleSectedItems(e, dataItem) }}>
        <Icon
          name={seletedItem ? 'delete' : 'circle outline'}
          color={seletedItem ? 'red' : 'grey'}
        />
      </div>
    </div>
  }

  const fnSub = (item) => {

    const { dataIssues } = item

    if (_.isArray(dataIssues)) {
      const lbls = _.map(dataIssues, dataIssue => {
        const { path, dups, rfz } = dataIssue

        if (rfz) {
          const divs = []
          _.forEach(rfz, rfzi => {
            const { originalItem, arrayKey, missingKey } = rfzi ?? {}
            const { _itemKey } = originalItem ?? {}
            const _name = convertHelpers.getItemName(originalItem)
            const xxx = <div style={{ display: 'flex', flexDirection: 'column', columnGap: '.5em' }}>
              <div style={{ paddingBottom: '.5em' }} >{`${_itemKey} - ${_name}`}</div>
              <div style={{ padding: '.5em', border: '1px solid var(--off-black-4)', borderRadius: '8px' }}>{`${arrayKey}: [${missingKey}]`}</div>
            </div>
            divs.push(xxx)
          })
          return divs
        }

        if (dups) {
          console.log('dups', dups)
          console.log('eventDups', eventDups)
          const divs = []
          _.forEach(dups, (dup, dupKey) => {
            const { originalItem, duplicateItems } = dup
            const _name = convertHelpers.getItemName(originalItem)
            const divItems = []
            const diKeys = _.mapValues(duplicateItems, (di) => di._itemKey)
            divItems.push(_.map(diKeys, k => (lbls_div(k, item))))
            // single div containing a dup
            const xxx = <div style={{ display: 'flex', flexDirection: 'column', columnGap: '.5em', rowGap: '.5em' }}>
              <div ><Icon name={'check'} color={'green'} /> {`${dupKey} - ${_name}`}</div>
              <div style={{ padding: '.5em', border: '1px solid var(--off-black-4)', borderRadius: '8px' }}>{_.map(duplicateItems, di => (lbls_remove(di?._itemKey, di, item, 10)))}</div>
            </div>
            divs.push(xxx)
          })
          return divs
        } else {
          return lbls_div(path, dataIssue)
        }
      })
      return <div style={{ display: 'flex', flexDirection: 'column', rowGap: '.5em' }}>{lbls}</div>
    }
  }

  const ims_dataIssues = () => <ItemMenuSquares
    menuItems={data_updates}
    imsType={_imsTypes.inline}
    fn_altContent={fnAlt}
    fn_subContent={fnSub}
    ignoreStartCase={true}
  />

  return ims_dataIssues()
}

export default ImsDataIssues